import React from 'react';
import PropTypes from 'prop-types';
import GDColorCodedCell from 'Components/GDTable/GDColorCodedCell';

const TimelineMerchant = (props) => {
  const { listItem } = props;
  return (
    <div className="content-header merchant">
      <h3 className="vertical-timeline-element-title merchant">{listItem.eventBodyDetails.MerchantName}</h3>
      <GDColorCodedCell content={listItem.eventBodyDetails.MerchantNumber} />
    </div>
  );
};

TimelineMerchant.propTypes = {
  listItem: PropTypes.object.isRequired,
};

TimelineMerchant.defaultProps = {

};
export default TimelineMerchant;
